var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"fill":"#85847C","fill-rule":"nonzero","d":"M10.607 1.414L9.586.394 5.5 4.478 1.414.393.394 1.414 4.478 5.5.393 9.586l1.021 1.02L5.5 6.522l4.086 4.086 1.02-1.021L6.522 5.5z"}})}
var staticRenderFns = []

export { render, staticRenderFns }